import { Claim, MaskedLine, Micro, Reveal, SlideBody, SlideShell } from "../shared";

const ColCard = ({ title, items, delay }) => (
  <Reveal delay={delay} className="h-full">
    <div className="flex h-full flex-col border border-[#0B152C]/12 bg-white p-6 lg:p-7">
      <h3 className="font-serif text-xl tracking-tight text-[#0B152C] lg:text-2xl">{title}</h3>
      <ul className="mt-5 space-y-3">
        {items.map((it) => (
          <li key={it} className="flex items-start gap-3 text-sm leading-relaxed text-[#334155]">
            <span className="mt-[9px] h-px w-4 shrink-0 bg-[#B8860B]" />
            {it}
          </li>
        ))}
      </ul>
    </div>
  </Reveal>
);

const Marquee = () => (
  <div className="pointer-events-none absolute inset-x-0 bottom-0 z-0 overflow-hidden border-t border-[#0B152C]/10 py-4">
    <div className="marquee-track">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center">
          {Array.from({ length: 4 }).map((_, i) => (
            <span
              key={i}
              className="mx-10 flex items-center gap-10 whitespace-nowrap font-serif text-lg italic text-[#0B152C]/30"
            >
              EVERY STAY. MORE VALUE.
              <span className="text-sm not-italic text-[#B8860B]/70">✦</span>
              5-STAR HOSPITALITY. PRIVATE VILLA LIVING.
              <span className="text-sm not-italic text-[#B8860B]/70">✦</span>
              THE BEST OF BOTH WORLDS.
              <span className="text-sm not-italic text-[#B8860B]/70">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default function Slide02Concetto() {
  return (
    <SlideShell theme="ivory" testid="slide-2-concetto">
      <SlideBody>
        <Reveal>
          <Micro tone="ivory">01 · Il Concetto</Micro>
        </Reveal>
        <h2 className="mt-5 font-serif text-4xl leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.1}>LA VILLA HA LO SPAZIO.</MaskedLine>
          <MaskedLine delay={0.22}>
            L&rsquo;HOTEL HA IL <em className="italic text-[#997A15]">SISTEMA.</em>
          </MaskedLine>
        </h2>

        <div className="mt-12 grid gap-4 lg:grid-cols-3">
          <ColCard
            title="LA VILLA"
            delay={0.35}
            items={[
              "Spazio e privacy assoluta",
              "Un'identità unica, irripetibile",
              "Nessuno standard operativo",
              "Nessun sistema di servizio",
            ]}
          />
          <Reveal delay={0.45} className="h-full">
            <div className="relative flex h-full flex-col items-center justify-center border border-[#B8860B]/50 bg-[#0B152C] p-6 text-center lg:p-7">
              <img src="/assets/villaflow-mark-light.png" alt="VillaFlow" className="h-11 w-auto" />
              <span className="mt-3 h-px w-10 bg-[#D4AF37]" />
              <p className="mt-4 font-serif text-lg italic leading-snug text-[#F3E5AB]">
                Lo spazio della villa.
                <br />
                Il sistema dell&rsquo;hotel.
              </p>
            </div>
          </Reveal>
          <ColCard
            title="L'HOTEL 5 STELLE"
            delay={0.55}
            items={[
              "Standard e servizio H24",
              "Un sistema operativo rodato",
              "Spazi condivisi, zero privacy",
              "Nessuna identità privata",
            ]}
          />
        </div>

        <Reveal delay={0.75} className="mt-10">
          <Claim tone="ivory">The best of both worlds.</Claim>
        </Reveal>
      </SlideBody>
      <Marquee />
    </SlideShell>
  );
}
